export class LeadModel {
    loan!: string;
    loan_purpose!: number;
    return_days!: number;
    user_agent: string;
    entry_url: string;
    window_size: string;
    isMobile: boolean;
    last_step: string;
    device_details: string;
    utm_source: string;
    sub_id: string;
    sid: string;
    email: string;
    mobile_number: string;
    application_path: string;
    referrer: string;
    user_ip: string;
    first_name: string;
    last_name: string;
    second_last_name: string;
    birthdate: string;
    gender: string;
    born_state?: number;
    personal_id: string;
    customer_RFC: string;
    dependents: number;
    has_facebook: boolean;
    accept_terms: boolean;
    locality?: number;
    street_name?: string;
    exterior_number?: string;
    interior_house?: string;
    employment_status?: number;
    monthly_salary?: number;
    has_bank_account?: boolean;
    clabe?: string;
    marital_status?: number;
    historial?: number;
    job_name?: string;
    money_market_status!: string;
    hasClabe: boolean;
    postal_code!: string;
    has_car!: boolean;
    time_at_job!: number;
    property_type!: number;


    constructor() {
        this.user_agent = "";
        this.entry_url = "";
        this.window_size = "";
        this.isMobile = true;
        this.last_step = "";
        this.device_details = "";
        this.utm_source = "";
        this.sub_id = "";
        this.sid = "";
        this.email = "";
        this.mobile_number = "";
        this.application_path = "";
        this.referrer = "";
        this.user_ip = "";
        this.first_name = '';
        this.last_name = '';
        this.second_last_name = '';
        this.birthdate = '';
        this.gender = '';
        this.personal_id = '';
        this.customer_RFC = '';
        this.dependents = 0;
        this.has_facebook = false;
        this.accept_terms = true;
        this.hasClabe = false;
    }
}